import React from 'react';
import { withStyles } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { withRouter } from '../../../../../util/router-compatibility';
import withJanusTokenReady from '../../withJanusTokenReady';
import { CasePlanDetailsContent } from './components/CasePlanDetailsContent';
import { CasePlanDetailsError } from './components/CasePlanDetailsError';
import { useCasePlanDetailsHook } from './useCasePlanDetailsHook';
import styles from './CasePlanDetails.styles';

function CasePlanDetails({ classes }) {
  const { casePlanId } = useParams();
  const {
    cardProps,
    sections,
    isViewOnly,
    isSectionsLoading,
    error,
    collapsedSections,
    handleBack,
    handleToggleCollapse,
    handleAddWidget,
    handleAddSection,
    handleEditorsClick,
    handleExportClick,
    isExportOpen,
    handleExportClose,
    handleExportSubmit,
  } = useCasePlanDetailsHook(casePlanId);

  const showError = error && !cardProps && !isSectionsLoading;
  if (showError) {
    return <CasePlanDetailsError classes={classes} error={error} onBack={handleBack} />;
  }

  return (
    <CasePlanDetailsContent
      classes={classes}
      cardProps={cardProps}
      sections={sections}
      isViewOnly={isViewOnly}
      isSectionsLoading={isSectionsLoading}
      collapsedSections={collapsedSections}
      onBack={handleBack}
      onToggleCollapse={handleToggleCollapse}
      onAddWidget={handleAddWidget}
      onAddSection={handleAddSection}
      onEditorsClick={handleEditorsClick}
      onExportClick={handleExportClick}
      isExportOpen={isExportOpen}
      onExportClose={handleExportClose}
      onExportSubmit={handleExportSubmit}
    />
  );
}

const StyledCasePlanDetails = withRouter(withStyles(styles)(CasePlanDetails));

export default withJanusTokenReady(StyledCasePlanDetails);
